import React from 'react';
import {TabPane} from 'reactstrap';
import {lobbyTabsEnum} from '../cellcomAbroadVariables';

const TabContentComponent = (props) => {
  let cssClasses = [`${props.tabId} tab-content-wrapper`];
  props.otpValidated &&
    (props.tabId == lobbyTabsEnum.BUSINESSACCOUNT || props.tabId == lobbyTabsEnum.PRIVATE) &&
    cssClasses.push('validated');
  props.packageTabLoader &&
    (props.tabId == lobbyTabsEnum.PACKAGEEXISTS || props.tabId == lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL) &&
    cssClasses.push('packageTabLoader');
  props.step2Validated && cssClasses.push('step2-validated');
  (!props.businessIndividualLobby && !props.otpValidated && !props.otpValidatedPackageTab && !props.step2Validated) ||
  (!props.customerAbroadPackagesRequestCompleted &&
    (props.tabId == lobbyTabsEnum.PACKAGEEXISTS || props.tabId == lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL))
    ? cssClasses.push('not-validated')
    : null;

  return (
    <TabPane tabId={props.tabId} className={cssClasses.join(' ')}>
      {props.component}
    </TabPane>
  );
};

export default TabContentComponent;
